import { ApiClient } from '@center-technologies/shared-api-clients';

export interface CreateRelationshipParams {
  fromSphereId: string;
  toSphereId: string;
  relationshipType: string;
  properties?: Record<string, any>;
}

export interface CreateRelationshipResult {
  success: boolean;
  relationshipId?: string;
  error?: string;
}

export async function createRelationship(
  graphClient: ApiClient,
  params: CreateRelationshipParams
): Promise<CreateRelationshipResult> {
  try {
    const requestBody = {
      relationship_type: params.relationshipType,
      target_sphere_id: params.toSphereId,
      properties: params.properties || {}
    };

    const response = await graphClient.post(`/relationships/${params.fromSphereId}`, requestBody);
    
    return {
      success: true,
      relationshipId: response?.id || response?.relationshipId
    };
  } catch (error: any) {
    console.error('Failed to create relationship:', error);
    
    // Extract user-friendly error message from API response
    let errorMessage = 'Failed to create relationship';
    
    if (error?.response?.data?.details) {
      // Use the user-friendly details message from the API
      errorMessage = error.response.data.details;
    } else if (error?.response?.data?.error) {
      // Fallback to the error field if no details
      errorMessage = error.response.data.error;
    } else if (error?.message) {
      // Fallback to the HTTP error message
      errorMessage = error.message;
    }
    
    return {
      success: false,
      error: errorMessage
    };
  }
}